import { useMutation, useQueryClient } from "react-query";
import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";

const useSignCharterPartyAgreement = () => {
  const { token } = useContext(AuthContext);
  const queryClient = useQueryClient();

  const signAgreement = async ({ requestId, body }) => {
    if (!token) throw new Error("Token is missing");
    if (!requestId) throw new Error("Request ID is required");
    if (body.signed === undefined) throw new Error("Signed status is required");
    
    const endpoint = `${process.env.REACT_APP_SERVER_URL}/charter/charterer/signCharterPartyAgreement/${requestId}`;
    const response = await fetch(endpoint, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || "Failed to sign charter party agreement");
    }
    return data;
  };

  const {
    mutate,
    isLoading,
    isSuccess,
    isError,
    error,
    data,
  } = useMutation(signAgreement, {
    onSuccess: () => {
      // Invalidate and refetch charter requests to get updated data
      queryClient.invalidateQueries(["readAllCharterRequests"]);
      queryClient.invalidateQueries(["readCharterRequest"]);
    },
  });

  return {
    signAgreement: mutate,
    isLoading,
    isSuccess,
    isError,
    error,
    data,
  };
};

export default useSignCharterPartyAgreement; 